export enum SearchPinKeyphraseErrorState {
	KEY_PHRASE_COLLISION = 'KEY_PHRASE_COLLISION',
	KEY_PHRASE_TOO_LONG = 'KEY_PHRASE_TOO_LONG',
	KEY_PHRASE_HAS_SPECIAL_CHAR = 'KEY_PHRASE_HAS_SPECIAL_CHAR',
	KEY_PHRASE_LIST_TOO_LONG = 'KEY_PHRASE_LIST_TOO_LONG',
	KEY_PHRASE_LIST_TOO_SHORT = 'KEY_PHRASE_LIST_TOO_SHORT',
	KEY_PHRASE_LIST_NON_UNIQUE = 'KEY_PHRASE_LIST_NON_UNIQUE',
}
